
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const finance = namespace("finance");
const base = namespace("base");
@Component({
  components: { ElImageViewer }
})
@Table("loadListData")
export default class InvoiceManagement extends Vue {
  @finance.Action getInvoiceList;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  searchForm = {
    invoiceNo: "",
    issueDateFrom: "",
    issueDateTo: "",
    titleName: "",
    orderNo: "",
    payOrderNo: ""
  };
  showViewer: boolean = false;
  invoiceTypeList: any = [];
  imgUrl: string = "";

  invoiceList: any[] = [];
  get searchList() {
    return [
      {
        label: this.$t("finance.serial-number"),
        type: "input",
        value: "",
        prop: "invoiceSn"
      },
      {
        label: t("finance.invoice-date"),
        type: "daterange",
        value: "",
        prop: "issueDateFrom"
      },
      {
        label: t("finance.invoice-type"),
        type: "select",
        value: "",
        selectList: this.invoiceTypeList,
        prop: "invoiceType"
      },
      {
        label: t("finance.invoice-title"),
        type: "input",
        value: "",
        prop: "titleName"
      },
      {
        label: t("finance.invoice-num"),
        type: "input",
        value: "",
        prop: "invoiceNo"
      },
      {
        label: t("finance.business-number"),
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: t("finance.receipt-payment-order-number"),
        type: "input",
        value: "",
        prop: "payOrderNo"
      }
    ];
  }
  emptyToLine = emptyToLine;
  created() {
    this.init();
  }
  closeViewer() {
    this.showViewer = false;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "issueDateFrom") {
          this.searchForm.issueDateFrom = item.value ? item.value[0] : "";
          this.searchForm.issueDateTo = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInvoiceList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.invoiceList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  handleViewInvoice(row) {
    if (row.invoiceUrl.includes("static.gtech.asia")) {
      this.imgUrl = row.invoiceUrl;
      this.showViewer = true;
    } else {
      window.open(row.invoiceUrl);
    }
  }
  handleLinkOrderView(orderNo) {
    let href = "";
    if (orderNo.includes("CG")) {
      href = this.$router.resolve({
        path: `/purchase/purchase-view/${orderNo}`
      }).href;
    } else {
      href = this.$router.resolve({
        path: `/service/view/${orderNo}`
      }).href;
    }
    window.open(href, "_blank");
  }
  handleReceiptView(receiptNo) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${receiptNo}`
    });
    window.open(href, "_blank");
  }
  init() {
    this.loadListData();
    this.getDictionaryList("invoice_type").then(data => {
      this.invoiceTypeList = data;
    });
  }
}
